import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../../context/AuthContext";
import {
  formatDate,
  MappingStatus,
  MappingStyles,
} from "../../../../utils/utils";

export default function ApprovedTable({
  selectedAll,
  handleSelectApplicant,
  selectedApplicants,
  handleSelectAll,
  filteredApplicants,
  handleViewApplication,
}) {
  const { user } = useAuth();
  const navigate = useNavigate();
  return (
    <div className="bg-[#131313] rounded-lg border border-[#333333] w-full overflow-x-auto scrollbar-hide">
      <table className="min-w-full text-sm border-separate border-spacing-0">
        <thead className="bg-[#131313] text-white">
          <tr>
            <th className="p-4 text-center border-x border-[#333333] rounded-tl-lg">
              <input
                type="checkbox"
                className="appearance-none h-5 w-5 border border-white rounded-sm bg-transparent checked:bg-yellow-400 checked:border-yellow-400 relative cursor-pointer
              before:content-['✓'] before:absolute before:text-white before:inset-0 before:flex before:items-center before:justify-center before:text-sm before:font-bold before:opacity-0 checked:before:opacity-100"
                checked={selectedAll}
                onChange={handleSelectAll}
              />
            </th>
            {[
              "DATE",
              "APPLICANT NAME",
              "LOAN AMOUNT",
              "CREDIT LIMIT",
              "PROCESSING TYPE",
              "BANK NAME",
              "APPROVED ON",
              "ACTIONS",
            ].map((heading, i) => (
              <th
                key={heading}
                className={`p-4 text-center border-x border-[#333333] ${
                  i === 8 ? "rounded-tr-lg" : ""
                }`}
              >
                {heading}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="text-white bg-[#131313]">
          {!filteredApplicants || filteredApplicants.length === 0 ? (
            <tr>
              <td colSpan="9" className="p-6 text-center text-gray-400">
                No rows found
              </td>
            </tr>
          ) : (
            filteredApplicants.map((applicant, index) => {
              const isLast = index === filteredApplicants.length - 1;
              return (
                <tr
                  key={applicant._id || index}
                  className={`border-b border-[#333333] ${
                    isLast ? "last:rounded-b-lg" : ""
                  }`}
                >
                  <td className="p-4 text-center border-x border-[#333333]">
                    <input
                      type="checkbox"
                      className="appearance-none h-5 w-5 border border-white rounded-sm bg-transparent checked:bg-yellow-400 checked:border-yellow-400 relative cursor-pointer
                    before:content-['✓'] before:absolute before:text-white before:inset-0 before:flex before:items-center before:justify-center before:text-sm before:font-bold before:opacity-0 checked:before:opacity-100"
                      checked={selectedApplicants.includes(applicant._id)}
                      onChange={() => handleSelectApplicant(applicant._id)}
                    />
                  </td>
                  <td className="p-4 text-center border-x border-[#333333]">
                    {formatDate(applicant.createdAt)}
                  </td>
                  <td className="p-4 text-center border-x border-[#333333]">
                    <div className="flex flex-col items-center gap-1">
                      {applicant.user?.name || applicant?.username || "N/A"}
                      {applicant.referredBy && (
                        <span className="text-xs text-[#FFCA20]">
                          Affiliate Application
                        </span>
                      )}
                    </div>
                  </td>
                  <td className="p-4 text-center border-x border-[#333333]">
                    <div>{applicant.principle}</div>
                    <div className="text-sm text-gray-400">
                      {applicant.loanType}
                    </div>
                  </td>
                  <td className="p-4 text-center border-x border-[#333333]">
                    <span
                      className={`px-3 py-1 rounded-full text-sm ${MappingStyles(
                        applicant.status
                      )}`}
                    >
                      {MappingStatus(applicant.status)}
                    </span>
                  </td>
                  <td className="p-4 text-center border-x border-[#333333]">
                    {applicant.processingMethod}
                  </td>
                  <td className="p-4 text-center border-x border-[#333333]">
                    {applicant.bankName || "N/A"}
                  </td>
                  <td className="p-4 text-center border-x border-[#333333]">
                    {formatDate(applicant.createdAt)}
                  </td>
                  <td className="p-4 text-center border-x border-[#333333]">
                    <button
                      className="text-[#FFCA20] hover:text-[#FFCA20]"
                      onClick={() => {
                        const role = user?.role?.toLowerCase();
                        if (
                          ["admin", "subadmin", "credit-manager"].includes(role)
                        ) {
                          navigate(
                            `/${role}/loan-applications/approval/${applicant._id}`
                          );
                        } else {
                          console.warn("Unknown role:", role);
                        }
                      }}
                    >
                      View
                    </button>
                  </td>
                </tr>
              );
            })
          )}
        </tbody>
      </table>
    </div>
  );
}
